import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9.83 8H11v6h2V8h1.17L12 5.83z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m12 3-7 7h4v6h6v-6h4l-7-7zm1 5v6h-2V8H9.83L12 5.83 14.17 8H13zM5 18h14v2H5z"
}, "1")], 'UploadTwoTone');